const keyboardTriggerBasic = (e: React.KeyboardEvent, callback: () => void, allowDefault?: boolean): void => {
  if (e.type === 'keydown' && ['Enter', ' '].indexOf(e.key) === -1) {
    return;
  }
  if (!allowDefault) {
    e.preventDefault();
    e.stopPropagation();
  }

  callback();
};

export default keyboardTriggerBasic;
